import { API_ASDI_CMS_BASE_URL } from 'config/constants'
import fetchHelper from 'library/FetchHelper'
import qs from 'qs'
import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import { setNotification } from '../actions'

const useGetNotification = (start = true) => {
  const dispatch = useDispatch()

  const getData = useCallback(
    (
      payload?: {
        isGetAll: true
      },
      cbs?: any,
      cbe?: any,
    ) => {
      const qStr = qs.stringify(payload)

      try {
        fetchHelper
          .fetch(`${API_ASDI_CMS_BASE_URL}/notification?${qStr}`, {
            method: 'GET',
          })
          .then(([resp, status]: any) => {
            if (status === 200) {
              let handleDataNotification = []
              if (resp.data?.data) {
                handleDataNotification = [
                  {
                    category: 'New',
                    children: resp.data?.data?.filter(
                      (item) => moment(item.createdAt).add(1, 'day').valueOf() >= new Date().getTime(),
                    ),
                  },
                  {
                    category: 'Earlier',
                    children: resp.data?.data?.filter(
                      (item) => moment(item.createdAt).add(1, 'day').valueOf() < new Date().getTime(),
                    ),
                  },
                ]
              }

              dispatch(setNotification(handleDataNotification))
              if (cbs) cbs(resp.data)
            } else if (cbe) cbe(resp)
          })
      } catch (error) {
        console.error('useGetNotification', error)
      }
    },
    [dispatch],
  )

  useEffect(() => {
    if (start) {
      getData()
    }
  }, [getData, start])

  return [getData]
}

export default useGetNotification
